import React, { Component } from 'react';
import { Layout, Card } from 'antd';
import styles from './index.module.less';
const ReactMarkdown = require('react-markdown/with-html');
import markdownSecurity from "./markdown_mobile";
import GFooter from '@/components/GlobalFooter';


class MobileLayout extends Component {

  render(){
    return (
      <Layout style={{ flexDirection: 'column' }}>
      <Layout.Content className={styles.content} style={{ display: 'flex', flexDirection: 'column' }}>
        <Card style={{ flex: 1 }}>
          <div className={styles.markdownContainer}>
                <ReactMarkdown source={markdownSecurity}></ReactMarkdown>
          </div>
        </Card>
      </Layout.Content>
      <Layout.Footer className={styles.footer}>
          <GFooter></GFooter>
      </Layout.Footer >
    </Layout>
    
    )
  } 
}

export default MobileLayout;